import { createContext, useContext, useState } from "react";
import { API_URL } from "../config";

const CatalogosContext = createContext();

export function CatalogosProvider({ children }) {
  const [catalogos, setCatalogos] = useState({
    estados: [],
    ciudades: [],
    grupos: [],
    asesores: [],
    cargados: false
  });

  const cargarCatalogos = async () => {
    if (catalogos.cargados) return; // ← YA ESTÁN CARGADOS

    try {
      const token = localStorage.getItem("token");
      const headers = { Authorization: `Bearer ${token}` };

      const [est, ciu, gru, ase] = await Promise.all([
        fetch(`${API_URL}/estados`, { headers }),
        fetch(`${API_URL}/ciudades`, { headers }),
        fetch(`${API_URL}/grupos`, { headers }),
        fetch(`${API_URL}/asesores`, { headers })
      ]);

      setCatalogos({
        estados: await est.json(),
        ciudades: await ciu.json(),
        grupos: await gru.json(),
        asesores: await ase.json(),
        cargados: true
      });

    } catch (err) {
      console.error("Error cargando catálogos:", err);
    }
  };

  return (
    <CatalogosContext.Provider value={{ ...catalogos, cargarCatalogos }}>
      {children}
    </CatalogosContext.Provider>
  );
}

export const useCatalogos = () => useContext(CatalogosContext);
